import { render } from "./SelectProjectForPackages.vue?vue&type=template&id=a11f77e2&scoped=true"
import script from "./SelectProjectForPackages.vue?vue&type=script&lang=js"
export * from "./SelectProjectForPackages.vue?vue&type=script&lang=js"

import "./SelectProjectForPackages.vue?vue&type=style&index=0&id=a11f77e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11f77e2"]])

export default __exports__